// Mock data for Investment Hub UK

export const TRUST_BADGES = [
  { label: "FCA Aware", sub: "Compliance-led ops" },
  { label: "SRA Advisors", sub: "Specialist legal panel" },
  { label: "Vetted Offers", sub: "Due-diligence first" },
  { label: "GDPR & ICO", sub: "Bank-level security" },
  { label: "5★ Trustpilot", sub: "Rated Excellent" },
  { label: "£612m+ Placed", sub: "For our investors" },
];

export const INVESTMENTS = [
  {
    slug: "buy-to-let-property",
    name: "Buy-to-Let Property",
    short: "UK rental portfolios",
    tagline: "Hands-off residential income from prime UK postcodes.",
    icon: "Home",
    yieldRange: "6–11% p.a.",
    minEntry: "£25,000",
    term: "3–7 years",
    risk: "Medium",
    hot: true,
    category: "Property",
    desc: "A managed portfolio of fully-tenanted residential units across Manchester, Liverpool, Leeds and Birmingham. Net rental yields paid quarterly, clean exit at capital uplift.",
    highlights: [
      "Fully-managed, hands-off ownership",
      "Quarterly net rental income",
      "SDLT-efficient SPV structures",
      "Independent RICS valuations",
    ],
  },
  {
    slug: "commercial-property",
    name: "Commercial Property",
    short: "Offices, retail & logistics",
    tagline: "Institutional-grade UK commercial assets with long leases.",
    icon: "Building2",
    yieldRange: "7–9% p.a.",
    minEntry: "£50,000",
    term: "5–10 years",
    risk: "Medium",
    hot: false,
    category: "Property",
    desc: "Co-invest into Grade A commercial property — last-mile logistics, regional offices and prime retail units — with 10-year+ lease covenants from blue-chip tenants.",
    highlights: [
      "FRI leases to vetted covenants",
      "Quarterly income distributions",
      "Inflation-linked rent reviews",
      "SPV-protected ownership",
    ],
  },
  {
    slug: "property-development",
    name: "Property Development",
    short: "HMO & new-build projects",
    tagline: "Fixed-term loan notes backed by UK development land.",
    icon: "HardHat",
    yieldRange: "10–14% p.a.",
    minEntry: "£10,000",
    term: "12–36 months",
    risk: "Medium-High",
    hot: true,
    category: "Property",
    desc: "Asset-backed loan notes funding HMO conversions and small-scale new-build schemes across England. First-charge security on land or completed stock.",
    highlights: [
      "First-charge legal security",
      "Fixed coupon, paid monthly",
      "Independent security trustee",
      "LTV capped at 65%",
    ],
  },
  {
    slug: "holiday-let-portfolio",
    name: "Holiday Let Portfolio",
    short: "Cornwall, Lakes & Scotland",
    tagline: "Premium short-stay properties in high-demand UK destinations.",
    icon: "Palmtree",
    yieldRange: "8–12% p.a.",
    minEntry: "£30,000",
    term: "3–5 years",
    risk: "Medium",
    hot: false,
    category: "Property",
    desc: "Fully-managed luxury short-let cottages and apartments in Cornwall, the Lake District and the Scottish Highlands. Peak-season nightly rates plus staycation capital growth.",
    highlights: [
      "Professional ARLA-regulated management",
      "FHL tax-efficient structure",
      "85%+ peak occupancy targets",
      "Owner usage weeks included",
    ],
  },
  {
    slug: "land-banking",
    name: "Strategic Land",
    short: "Pre-planning UK plots",
    tagline: "Long-hold strategic land in the path of UK growth corridors.",
    icon: "Map",
    yieldRange: "Uplift 2–5x",
    minEntry: "£15,000",
    term: "5–10 years",
    risk: "High",
    hot: false,
    category: "Property",
    desc: "Acquire plots in pre-planning UK growth zones — Oxford-Cambridge Arc, M1 corridor and SE commuter belt — held in trust until planning permission unlocks value.",
    highlights: [
      "Title held in your name",
      "Legal pack & Land Registry plan",
      "In-house planning team",
      "Exit-managed to housebuilders",
    ],
  },
  {
    slug: "corporate-bonds",
    name: "Corporate Bonds",
    short: "UK & global fixed income",
    tagline: "Curated portfolio of investment-grade UK & global corporate bonds.",
    icon: "Receipt",
    yieldRange: "5–8% p.a.",
    minEntry: "£5,000",
    term: "2–7 years",
    risk: "Low-Medium",
    hot: false,
    category: "Fixed Income",
    desc: "Access a managed ladder of investment-grade corporate bonds from FTSE 100 issuers and global blue-chips. Coupons paid semi-annually with full liquidity at maturity.",
    highlights: [
      "BBB+ minimum issuer rating",
      "Semi-annual fixed coupons",
      "Diversified across 30+ issuers",
      "Held in nominee custody",
    ],
  },
  {
    slug: "uk-gilts",
    name: "UK Gilts & Treasury",
    short: "Government-backed income",
    tagline: "HM Treasury-backed gilts — the bedrock of every UK portfolio.",
    icon: "Landmark",
    yieldRange: "4–5% p.a.",
    minEntry: "£1,000",
    term: "1–30 years",
    risk: "Low",
    hot: false,
    category: "Fixed Income",
    desc: "Direct access to UK gilts and short-dated treasury bills. CGT-exempt on capital gains, low correlation to equities — built for capital preservation.",
    highlights: [
      "HM Treasury backed",
      "CGT-exempt capital gains",
      "Daily liquidity",
      "Laddered maturity strategy",
    ],
  },
  {
    slug: "stocks-shares-isa",
    name: "Stocks & Shares ISA",
    short: "£20k tax-free per year",
    tagline: "Tax-free UK & global equities, managed to your risk appetite.",
    icon: "TrendingUp",
    yieldRange: "7–10% target",
    minEntry: "£500",
    term: "Open-ended",
    risk: "Medium",
    hot: true,
    category: "Equity",
    desc: "Use your full £20,000 ISA allowance across a diversified portfolio of UK and global equities, ETFs and index funds. Zero CGT, zero dividend tax — forever.",
    highlights: [
      "£20,000 annual tax-free allowance",
      "Zero CGT, zero dividend tax",
      "Three managed risk profiles",
      "Withdraw any time, no penalty",
    ],
  },
  {
    slug: "sipp-pension",
    name: "SIPP Pension Portfolio",
    short: "Tax-relief & retirement",
    tagline: "Self-invested pensions with up to 45% tax relief on contributions.",
    icon: "PiggyBank",
    yieldRange: "6–9% target",
    minEntry: "£10,000",
    term: "To age 55+",
    risk: "Medium",
    hot: false,
    category: "Pension",
    desc: "A fully-flexible SIPP wrapper allowing equities, bonds, commercial property and alternative assets. HMRC tax relief grosses up every contribution.",
    highlights: [
      "Up to 45% HMRC tax relief",
      "Tax-free growth",
      "Drawdown or annuity at 55+",
      "25% tax-free lump sum",
    ],
  },
  {
    slug: "vct-eis-seis",
    name: "VCT, EIS & SEIS",
    short: "Tax-advantaged growth",
    tagline: "30–50% income tax relief on UK growth-stage investments.",
    icon: "Rocket",
    yieldRange: "10–25% target",
    minEntry: "£10,000",
    term: "3–7 years",
    risk: "High",
    hot: true,
    category: "Tax-Advantaged",
    desc: "Co-invest into HMRC-approved VCT, EIS and SEIS schemes backing British scale-ups — claim 30% (VCT/EIS) or 50% (SEIS) income tax relief plus CGT-free exits.",
    highlights: [
      "30–50% income tax relief",
      "CGT-free on qualifying exits",
      "Loss relief on failed positions",
      "IHT-free after 2 years (EIS/SEIS)",
    ],
  },
  {
    slug: "renewable-energy",
    name: "Renewable Energy Funds",
    short: "UK wind, solar & storage",
    tagline: "Government-contracted UK renewable infrastructure with index-linked income.",
    icon: "Leaf",
    yieldRange: "7–9% p.a.",
    minEntry: "£25,000",
    term: "7–15 years",
    risk: "Medium",
    hot: false,
    category: "Alternative",
    desc: "Long-dated infrastructure exposure to UK wind, solar and battery storage assets backed by 15-year CfD government contracts. RPI-linked income.",
    highlights: [
      "15-year CfD government contracts",
      "RPI-linked income stream",
      "Low correlation to equities",
      "ESG / Article 9 classified",
    ],
  },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Tell us your goals",
    desc: "Answer a few quick questions about your timeline, target income and risk appetite — takes under 60 seconds, completely free.",
    icon: "Target",
  },
  {
    step: "02",
    title: "We match the offer",
    desc: "Our specialists screen our vetted panel against your profile and surface the 2–3 strongest live offers — no commission bias.",
    icon: "FileSearch",
  },
  {
    step: "03",
    title: "Due-diligence pack",
    desc: "You receive a full investor pack: legals, security structure, track record and independent third-party reviews. Ask anything.",
    icon: "Briefcase",
  },
  {
    step: "04",
    title: "Subscribe & earn",
    desc: "Subscribe digitally with full FCA-aware paperwork. Income lands in your account on schedule — track everything in your portal.",
    icon: "Wallet",
  },
];

export const STATS = [
  { value: "£612m+", label: "Capital placed", sub: "Across the platform since 2019" },
  { value: "4,200+", label: "Active investors", sub: "UK HNW & sophisticated" },
  { value: "98%", label: "Coupons on time", sub: "Every quarter since launch" },
  { value: "11", label: "Vetted sectors", sub: "From gilts to growth VCTs" },
];

export const WHY_US = [
  {
    title: "Vetted before you ever see them",
    desc: "Less than 6% of offers we review reach the platform. Every issuer is screened on legals, track record and security.",
    icon: "ShieldCheck",
  },
  {
    title: "FCA-aware, transparently fee'd",
    desc: "We follow FCA standards for financial promotions and S21 approval. Every fee and risk is disclosed upfront.",
    icon: "BadgeCheck",
  },
  {
    title: "Independent legal & RICS partners",
    desc: "Property is RICS-valued, security packs are reviewed by an independent City law firm. We never mark our own homework.",
    icon: "Scale",
  },
  {
    title: "A real investor portal",
    desc: "Track every position, coupon, valuation and document in one place. Real-time. No quarterly PDFs.",
    icon: "MonitorSmartphone",
  },
];

export const TESTIMONIALS = [
  {
    initials: "JR",
    name: "James R.",
    location: "Chelsea, London",
    type: "Buy-to-Let Property",
    amount: "£185k placed",
    quote:
      "I'd been priced out of London BTL for years. Investment Hub matched me with a Manchester portfolio yielding 8.9% net. Income has landed every quarter on the dot.",
  },
  {
    initials: "PE",
    name: "Priya E.",
    location: "Edinburgh",
    type: "VCT & EIS",
    amount: "£62k placed",
    quote:
      "I wanted EIS exposure without hunting deals myself. Got a clean, diversified portfolio across 12 British scale-ups and an £18k tax rebate the same year.",
  },
  {
    initials: "MH",
    name: "Michael H.",
    location: "Surrey",
    type: "Property Development",
    amount: "£250k placed",
    quote:
      "The first-charge security and independent trustee made the difference for me. Coupons paid monthly, full exit at month 24 — exactly as written.",
  },
  {
    initials: "AC",
    name: "Anna C.",
    location: "Manchester",
    type: "Renewable Energy",
    amount: "£90k placed",
    quote:
      "As a doctor, I wanted ESG exposure that wasn't greenwashed. The CfD-backed wind portfolio is paying RPI+5% — and I sleep well at night.",
  },
  {
    initials: "DK",
    name: "David K.",
    location: "Leeds",
    type: "Stocks & Shares ISA",
    amount: "£40k placed",
    quote:
      "Used my full ISA allowance for two years running. Up 22% net and not a penny in CGT or dividend tax. Brilliant onboarding.",
  },
  {
    initials: "SF",
    name: "Sarah F.",
    location: "Bristol",
    type: "SIPP Pension",
    amount: "£140k placed",
    quote:
      "I consolidated three legacy pensions into a single SIPP through Investment Hub. The tax relief alone funded my next contribution.",
  },
];

export const FAQS = [
  {
    q: "Is Investment Hub UK regulated?",
    a: "We are FCA-aware and operate within the boundaries of FCA Section 21 financial promotion rules. All offers carrying regulated activity are issued or arranged by FCA-authorised counterparties, and every promotion is approved by an FCA-authorised firm before reaching our platform.",
  },
  {
    q: "What's the minimum investment?",
    a: "Minimums vary by product. UK gilts and Stocks & Shares ISA start from £500 – £1,000. Most property, bond and renewable offers start from £10,000 – £25,000. Each live offer states its minimum on the deal page.",
  },
  {
    q: "Are these investments protected by the FSCS?",
    a: "Some products (e.g. SIPP and ISA wrappers operated by FCA-authorised counterparties) carry FSCS protection up to £85,000. Many higher-yielding offers (loan notes, direct property, EIS/VCT) sit outside FSCS protection. We disclose the exact protection status on every offer page — in writing, before you commit.",
  },
  {
    q: "How are my funds protected on alternative offers?",
    a: "Most non-FSCS offers use one or more of: first-charge legal security over UK property, an independent security trustee, segregated SPV ownership, or HMRC-approved tax-advantaged structures (VCT/EIS/SEIS) with statutory loss relief.",
  },
  {
    q: "What fees do you charge?",
    a: "Investment Hub UK does not charge investors a subscription fee. We receive a transparent placement fee from issuers, capped within FCA standards, and we disclose every fee in writing on the offer page before you subscribe.",
  },
  {
    q: "Do I need to be a 'sophisticated' or 'high-net-worth' investor?",
    a: "Some offers (notably EIS, VCT and direct property loan notes) are restricted under FCA rules to certified High-Net-Worth Individuals or Self-Certified Sophisticated Investors. We carry out the appropriate appropriateness assessment during onboarding.",
  },
  {
    q: "Can I sell my investment early?",
    a: "It depends. Gilts, ISA and corporate-bond positions are typically liquid daily. Property, development loan notes and renewable infrastructure are illiquid — capital is locked for the stated term, though a best-endeavours secondary market is offered on most.",
  },
  {
    q: "Is my data secure?",
    a: "Yes. We are ICO-registered, GDPR-by-default, with bank-grade encryption in transit and at rest in UK data centres. We never sell, share or rent your details. Full stop.",
  },
];

export const FOOTER = {
  company: "Connexis Group Ltd",
  brand: "Investment Hub UK",
  companyNo: "17214446",
  address: "71-75 Shelton Street, Covent Garden, London, WC2H 9JQ",
  email: "investors@investhubuk.co.uk",
  phone: "020 3728 6215",
  ico: "ZB-754201",
  disclaimer:
    "Investments referenced on this website are not protected by the Financial Services Compensation Scheme unless explicitly stated. The value of investments can fall as well as rise; past performance is not a reliable indicator of future results. Tax treatment depends on individual circumstances and may change. Investment Hub UK is a trading style of Connexis Group Ltd. Financial promotions on this site are approved by an FCA-authorised firm in accordance with section 21 of the Financial Services and Markets Act 2000.",
};
